import { Button } from 'blaze-ui/Button'
import { GenerateButtonProps } from 'components/Wizards/Field/Types'
import { useField, useFormikContext } from 'formik'
import { useSections } from 'components/Wizards/Wizard/Form/Sections/SectionsProvider'
import { useCreateAITypeaheadOptions } from 'hooks/queries/aiTypeahead/useCreateAITypeaheadOptions'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'
import { useEffect, useRef } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const GenerateMoreButton = ({ field: fieldName, onPress, onSettled: onComplete, size }: GenerateButtonProps) => {
  const [field, , { setValue }] = useField(fieldName)
  const { type } = useSections()
  const { setStatus, initialStatus } = useFormikContext<{ [key: string]: any }>()
  const abortController = useRef<AbortController | null>(null)
  const { isMobile } = useResponsiveDesign()

  const { mutateAsync, isLoading } = useCreateAITypeaheadOptions()

  useEffect(() => {
    abortController.current?.abort()
  }, [field.value])

  const handlePress = async () => {
    onPress()
    setStatus(initialStatus)
    abortController.current?.abort()
    try {
      abortController.current = new AbortController()
      const data = await mutateAsync({
        text: field.value,
        generationType: type,
        signal: abortController.current?.signal,
      })
      if (data?.options && data.options.length > 0) {
        await setValue(data.options[0])
        setStatus(FormStatus.AutoCompleted)
      }
    } catch {
      setStatus(initialStatus)
    } finally {
      onComplete()
    }
  }

  return (
    <Button variant="secondary" size={isMobile ? size : 'xs'} onPress={handlePress} isDisabled={isLoading}>
      Generate More Context for Me
    </Button>
  )
}
